import { render, staticRenderFns } from "./TaskApproverCell.vue?vue&type=template&id=dcb5d6ea"
import script from "./TaskApproverCell.vue?vue&type=script&lang=js"
export * from "./TaskApproverCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports